<script setup lang="ts">
import Button from "../components/form/Button.vue";

import { useRouter } from "../hooks";
const router = useRouter();

function gotoShape() {
  router.push("/shape");
}

function gotoShowcase() {
  router.push("/cs");
}

function gotoXGLot() {
  router.push("/lot");
}

function gotoRxmarbles() {
  router.push("/rx");
}
</script>
<template>
  <div>
    <div class="gap">
      <Button @throttle-click="gotoShape">Shape</Button>
    </div>
    <div class="gap">
      <Button @throttle-click="gotoShowcase">Component ShowCase</Button>
    </div>
    <div class="gap">
      <Button @throttle-click="gotoXGLot">XG lot</Button>
    </div>
    <div class="gap">
      <Button @throttle-click="gotoRxmarbles">Rx Marbles</Button>
    </div>
  </div>
</template>

<style scoped>
.gap {
  padding: 10px;
}
</style>
